<!-- Trigger button -->
@if(isGlobalUser) {
<button
  [matMenuTriggerFor]="hubMenu"
  class="hub-menu__trigger"
  [ngClass]="{
    'hub-menu__trigger--workspace btn btn--sm btn--outline':
      triggerStyle === 'workspace',
    'hub-menu__trigger--general': triggerStyle === 'general',
    'hub-menu__trigger--mobile': triggerStyle === 'mobile',
    'hub-menu__trigger--active': isHubsRouteActive
  }"
>
  <fa-icon [icon]="['fasr', 'grid-2']" class="hub-menu__trigger-icon"></fa-icon>
  <span class="hub-menu__trigger-label">{{
    'HUBS.TITLE_LIST' | translate
  }}</span>
  <fa-icon
    [icon]="['fass', 'chevron-down']"
    class="hub-menu__trigger-chevron"
  ></fa-icon>
</button>
} @else if(currentHub || otherHubs?.length) {
<button
  [matMenuTriggerFor]="hubMenu"
  class="hub-menu__trigger"
  [ngClass]="
    triggerStyle === 'workspace'
      ? 'hub-menu__trigger--workspace btn btn--sm btn--outline'
      : triggerStyle === 'mobile'
      ? 'hub-menu__trigger--mobile'
      : 'hub-menu__trigger--general'
  "
>
  <app-image-loader
    [singleImage]="getLogoImage(currentHub)"
    [type]="imageTypes.LOGO"
    class="hub-menu__trigger-logo"
  ></app-image-loader>
  <span>{{ currentHub?.instance?.name }}</span>
  <i class="fa fa-chevron-down hub-menu__trigger-icon"></i>
</button>
}

<mat-menu #hubMenu="matMenu">
  @if(isGlobalUser) { @if(_allHubs?.length) {
  @for (hub of _allHubs; track hub) {
<button mat-menu-item (click)="selectHub(hub)">
    <app-image-loader
      [singleImage]="getLogoImage(hub)"
      [type]="imageTypes.LOGO"
      class="hub-menu__logo"
    ></app-image-loader>
    <span>{{ hub?.instance?.name }}</span>
  </button>
}
  } @else {
  <div class="hub-menu__empty-message" mat-menu-item disabled>
    <span>{{ 'HUBS.NO_WORKSPACES' | translate }}</span>
  </div>
  }

  <div class="separator"></div>

  <button mat-menu-item (click)="exploreWorkspaces()">
    <fa-icon [icon]="['fasr', 'compass']"></fa-icon>
    <span>{{ 'HUBS.EXPLORE_WORKSPACES' | translate }}</span>
  </button>
  } @else {
  <!-- Workspace user: Current hub + other hubs -->
  @if (currentHub) {
<button mat-menu-item (click)="goHome()">
    <app-image-loader
      [singleImage]="getLogoImage(currentHub)"
      [type]="imageTypes.LOGO"
      class="hub-menu__logo"
    ></app-image-loader>
    <span> {{ 'HUBS.GO_TO_HOME' | translate }}</span>
  </button>
}

  @if(otherHubs?.length) {
  @for (hub of otherHubs; track hub) {
<button mat-menu-item (click)="selectHub(hub)">
    <app-image-loader
      [singleImage]="getLogoImage(hub)"
      [type]="imageTypes.LOGO"
      class="hub-menu__logo"
    ></app-image-loader>
    <span>{{ hub?.instance?.name }}</span>
  </button>
}
  }

  @if (showExploreMeplis) {

    <div class="separator"></div>

    <button
      mat-menu-item
      class="hub-menu__explore-button"
      (click)="exploreMeplis()"
    >
      <fa-icon [icon]="['fass', 'lock-open']"></fa-icon>
      <span>{{ 'HUBS.EXPLORE_MEPLIS' | translate }}</span>
    </button>
  
}
  }
</mat-menu>
